import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Cuberover from "./views/Cuberover.vue";
import OffBeat from "./views/OffBeat.vue";
import About from "./views/About.vue";
import Hyperloop from "./views/Hyperloop.vue";
import Radpiper from "./views/Radpiper.vue";
import Fish from "./views/Fish.vue";
import Visualization from "./views/Visualization.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/cuberover",
      name: "cuberover",
      component: Cuberover
    },
    {
      path: "/offbeat",
      name: "offbeat",
      component: OffBeat
    },
    {
      path: "/hyperloop",
      name: "hyperloop",
      component: Hyperloop
    },
    {
      path: "/radpiper",
      name: "radpiper",
      component: Radpiper
    },
    {
      path: "/fish",
      name: "fish",
      component: Fish
    },
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      path: "/vis",
      name: "visualization",
      component: Visualization
    }
  ]
});
